import { useMemo, useState } from "react";
import { IDictionary } from "shared/types";

export const useUniqueDictionaries = (
  dictionaries: IDictionary[],
  isMobile: boolean
) => {
  const [selectedDictionary, setSelectedDictionary] =
    useState<IDictionary | null>(isMobile ? null : dictionaries[0]);

  const uniqueDictionaries = useMemo(() => {
    const map = new Map<string, (typeof dictionaries)[number]>();

    dictionaries.forEach((item) => {
      if (!map.has(item.type)) {
        map.set(item.type, item);
      }
    });
    return Array.from(map.values());
  }, [dictionaries]);

  return { uniqueDictionaries, selectedDictionary, setSelectedDictionary };
};
